module.exports = __webpack_public_path__ + "img/industryScore.0500f49b.png";